import { render, staticRenderFns } from "./PopupFilters.vue?vue&type=template&id=252c17e2"
import script from "./PopupFilters.vue?vue&type=script&lang=ts"
export * from "./PopupFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports